import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { LightsSettingsSupportType } from '@shure/shared/angular/features/device-lights-settings/data-access';
import {
	LightsImage,
	LightsImageProvider
} from '@shure/shared/angular/features/device-lights-settings/feature-device-image-next';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class Mxa710CdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin implements LightsImageProvider {
	public override readonly models: DeviceModel[] = [DeviceModel.MXA7102FT, DeviceModel.MXA7104FT];

	public override getLightsSettingsSupportType(): LightsSettingsSupportType {
		return LightsSettingsSupportType.Supported;
	}

	public getLightsImage(): LightsImage {
		return {
			imageUrl: 'device-mxa7xx.svg'
		};
	}
}
